import BankLinkModal from "./bank-link-modal.component";

export default BankLinkModal;
